import { getPageVisibilityState } from './getPageVisibilityState';
export function addOnVisibilityChangeListener(callback) {
    var listener = function () { return callback(getPageVisibilityState()); };
    document.addEventListener('visibilitychange', listener);
    return listener;
}
export function removeOnVisibilityChangeListener(listener) {
    document.removeEventListener('visibilitychange', listener);
}
//# sourceMappingURL=Listeners.js.map